<template>
  <div class="faq-wrapper">
    <div
      class="d-flex justify-content-end align-items-center color-wealthy-green-500 mr-4"
    >
      <div
        v-b-toggle.faq-sidebar-right
        class="drip-text-button d-flex align-items-center"
      >
        <b-icon-x scale="1.6" />
      </div>
    </div>
    <div class="section-heading">
      {{ $t('account.index.currencySettings.faq.pageHeading') }}
    </div>
    <div class="faq-accordion" role="tablist">
      <b-card no-body class="mb-4" v-for="(faq, i) in faqs" :key="i">
        <b-card-header
          header-tag="header"
          class="faq-accordion-header"
          role="tab"
          @click="setActiveAccordion(i, faq.heading)"
        >
          <b-icon-triangle-fill
            flip-v
            class="mr-3 color-noble-blue-500"
            :class="{
              'rotate-icon': activeAccordion === i,
              'unrotate-icon': activeAccordion !== i
            }"
          />
          {{ faq.heading }}
        </b-card-header>
        <b-collapse
          accordion="faq-accordion-collapse"
          role="tabpanel"
          :visible="activeAccordion === i"
          :id="'accordion-' + i"
        >
          <b-card-body class="faq-accordion-body">
            {{ faq.body }}
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeAccordion: null
    }
  },
  computed: {
    faqs() {
      return this.$t('account.index.currencySettings.faq.questions')
    }
  },
  methods: {
    setActiveAccordion(index, question) {
      this.$mpTrack('Faq clicked', { question })
      if (this.activeAccordion === index) {
        this.activeAccordion = null
        return
      }
      this.activeAccordion = index
    },
    isActive(index) {
      return this.activeAccordion === index
    }
  }
}
</script>
<style lang="scss">
@import '../../../assets/scss/palette';
.faq-wrapper {
  margin-top: 32px;

  .section-heading {
    font-size: 1.25rem;
    margin-left: 16px;
    font-weight: bold;
    color: map-get($noble-blue, 500);
    text-align: left;
    margin-bottom: 36px;
  }
  .faq-accordion {
    margin: 0px 16px;
    .card {
      box-shadow: none;
    }
    .faq-accordion-header {
      text-align: left;
      background: map-get($sky-blue, 50);
      cursor: pointer;
      .rotate-icon {
        transform: rotate(180deg);
        transition: all 0.15s ease-in;
      }
      .unrotate-icon {
        transform: rotate(0deg);
        transition: all 0.15s ease-in;
      }
    }
    .faq-accordion-body {
      text-align: left;
      border: 1px solid map-get($neutral-grey, 100);
      border-top: 0px;
      box-sizing: border-box;
      border-radius: 0.5rem;
      border-top-right-radius: 0rem;
      border-top-left-radius: 0rem;
    }
  }
}
</style>
